import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('temporaryDrawerHeadingGroup', [
  'header',
  'heading',
  'subheading',
  'toolbar',
  'backAction',
]);

const getHeadingGroupCss = css`
  display: flex;
  padding: 0 var(--cds-spacing-200) var(--cds-spacing-150);

  .${classes.header} {
    flex: 1 1 auto;
  }

  .${classes.toolbar} {
    display: flex;
    flex: 0 0 auto;
    margin-bottom: var(--cds-spacing-50);
  }

  .${classes.subheading} {
    margin-top: var(--cds-spacing-50);
  }

  ${breakpoints.up('sm')} {
    padding: 0 var(--cds-spacing-200) var(--cds-spacing-150);
  }

  ${breakpoints.up('md')} {
    padding-left: var(--cds-spacing-300);
    padding-right: var(--cds-spacing-300);
    padding-bottom: var(--cds-spacing-200);
  }
`;

export default getHeadingGroupCss;
